import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface AssessmentToolCardProps {
  icon: string;
  title: string;
  description: string;
  features: string[];
  estimatedTime: string;
  buttonText: string;
}

const AssessmentToolCard = ({ 
  icon, 
  title, 
  description, 
  features, 
  estimatedTime,
  buttonText 
}: AssessmentToolCardProps) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-subtle hover:shadow-elevation transition-all duration-300 border border-border">
      <div className="flex items-start space-x-4 mb-4">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name={icon as any} size={24} className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-display font-semibold text-foreground mb-2">
            {title}
          </h3>
          <p className="text-muted-foreground text-sm">
            {description}
          </p>
        </div>
      </div>
      
      <div className="space-y-2 mb-4">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start space-x-2">
            <Icon name="CheckCircleIcon" size={16} className="text-success mt-0.5 flex-shrink-0" variant="solid" />
            <span className="text-sm text-foreground">{feature}</span>
          </div>
        ))}
      </div>
      
      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="ClockIcon" size={16} />
          <span>{estimatedTime}</span>
        </div>
        <button className="px-4 py-2 bg-primary text-white rounded-lg font-semibold hover:bg-primary/90 transition-all duration-300 flex items-center space-x-2">
          <span>{buttonText}</span>
          <Icon name="ArrowRightIcon" size={16} />
        </button>
      </div>
    </div>
  );
};

export default AssessmentToolCard;